<div id="preauthWrapper">
    <div class="preauth-dialog">
        <div id="divErrorInactiveAccount">
            <h1>There's a problem with your account</h1>
            <p>Our records show that {{hostname}} is inactive. Sorry about that.</p>
            <h2>So now what?</h2>
            <ol class="numbered">
                <li>Did you cancel your Buildium account? We'd love to have you back! Give us a ring at <strong>888-414-1988</strong> (or 617-600-0448) and we'll have you back up and running in no time.</li>
                <li>Maybe there's a problem with your billing information? Did your bank account number change or credit card expire?<br />Call us at <strong>888-414-1988</strong> (or 617-600-0448) so we can straighten things out.</li>
                <li>Have you been away for a while? For your security, we sometimes inactivate accounts that haven't been accessed in a long time. Call us at <strong>888-414-1988</strong> (or 617-600-0448) and we'll help you get going again.</li>
            </ol>
        </div>
    </div>
</div>
